import React from "react";
import GameButtonWithIcon from "../GameButtonWithIcon";
import info_icon from "../../../images/gameplay_ui/icons/info_icon.svg";
import loco_icon from "../../../images/gameplay_ui/icons/loco_icon.svg";

import loco_brigade_icon from "../../../images/gameplay_ui/icons/loco_brigade_icon.svg"
import brigade_icon from "../../../images/gameplay_ui/icons/brigades_icon.svg"
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg"

import {STATION_HEADER_COLORS} from "../GameStyleUI";
import GameButtonWithText from "../GameButtonWithText";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import GameData from "../../../gameplay/model/GameData";
import GameController from "../../../gameplay/controllers/GameController";
import TrainCard from "../GeneralCards/TrainCard";
import BuyLocoPopup from "../Popups/BuyLocoPopup";
import BuyContractorsPopup from "../Popups/BuyContractorsPopup";
import BuyWorkhourPopup from "../Popups/BuyWorkhourPopup";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class StationPanel extends React.Component {
    constructor(props) {
        super(props);
        this.popup = null;

        let trainMasterIndex = UtilsFunctions.getRoleNameIndex("Заместитель по тяге");
        this.isTrainMaster = UtilsFunctions.playerHasRole(trainMasterIndex);
    }

    isBottomCard() {
        let station = this.props.station;
        return station.id === 0 || station.id === 3;
    }

    isRightCard() {
        let station = this.props.station;
        return station.id === 2 || station.id === 3;
    }

    showSortPopup() {
        this.props.onSortButton(this.props.station);
    }

    showRepairPopup() {
        this.props.onRepairButton(this.props.repairShop);
    }

    showCreateTrainPopup() {
        let station = this.props.station;
        if (GameController.calculateAvailableLocoBrigades(station) === 0) {
            alert("Недостаточно локомотивных бригад для формирования поезда. Расфомируйте один из поездов.")
            return;
        }
        this.props.onCreateTrainButton(station);
    }

    getCurrentStateButton(colors) {
        let pushStyle = {
            margin: "5px"
        }
        switch (GameData.CurrentGame.state) {
            default:
                return "";
            case 2:
                return <GameButtonWithText
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    width={194}
                    height={40}
                    fontSize={20}
                    title={"Сортировка"}
                    style={pushStyle}

                    onClick={this.showSortPopup.bind(this)}
                />
            case 3:
                if (this.props.station.id !== 1 && this.props.station.id !== 3) return "";
                return <GameButtonWithText
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    width={194}
                    height={40}
                    fontSize={20}
                    title={"Ремонт"}
                    style={pushStyle}
                    onClick={this.showRepairPopup.bind(this)}
                />
            case 4:
                return <GameButtonWithText
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    width={194}
                    height={40}
                    fontSize={20}
                    title={"Формирование"}
                    style={pushStyle}
                    onClick={this.showCreateTrainPopup.bind(this)}
                />
        }

        //onClick={this.add.bind(this)}

    }

    getTrainCards() {
        let trains = GameData.CurrentGame.getStationTrains(this.props.station.id);
        let trainCards = [];
        for (let i = 0; i < trains.length; i++) {
            let train = trains[i];
            if (!GameData.CurrentGame.isTrainOnAnyPath(train))
                trainCards.push(<TrainCard isCanFree={this.isTrainMaster} key={this.props.station.id * 100 + i}
                                           train={train}
                                           teamID={this.props.teamID} parent={this}/>)
        }
        return <div style={{
            display: "flex"
        }}>{trainCards}</div>;
    }

    handlePopup(thePopup) {
        let currentType = this.popup ? this.popup.type.name : "";
        this.popup = currentType === thePopup.type.name ? null : thePopup;
        this.props.updatePopup(this.props.station.id);
    }

    closeByX(popup) {
        let equal = GameController.sameCard(this.popup.props, popup.props);

        if (equal) {
            this.popup = null;
            this.props.updatePopup(this.props.station.id);
        }
    }

    render() {
        if (!this.props.canShow)
            this.popup = null;

        let station = this.props.station;
        let mainStyle = {
            width: "204px",
            height: "228px",
            borderRadius: "5px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }
        let p5 = {
            padding: "5px"
        }
        let block1 = {
            width: "204px",
            height: "85px",
            background: "rgba(0, 0, 0, 0.5)"
        }

        let block2 = {
            width: "204px",
            height: "140px",
            justifyContent: "space-between",
            display: "flex",
            flexDirection: "column",
            background: "rgba(0, 0, 0, 0.5)"
        }
        let cardResource = {
            height: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "5px",
            paddingTop: 0
        }
        let colors = STATION_HEADER_COLORS[station.id];

        let stationWorkhours = GameController.calculateAvailableStationBrigadesChips(station);

        let trainCardsStyle = {
            paddingTop: "10px",
            position: "absolute",
            bottom: "-95px"
        };

        return <div style={{
            display: "flex",
            alignItems: this.isBottomCard() ? "flex-end" : "flex-start"
        }}>
            {this.props.canShow && (!this.isRightCard() ? this.popup : "")}
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: station.id < 2 ? "flex-end" : "flex-start",
                position: "relative"
            }}>
                {this.isBottomCard() ? <div style={{paddingBottom: "10px"}}>{this.getTrainCards()}</div> : ""}
                <div style={mainStyle}>
                    <div style={block1}>
                        <div style={p5}>
                            <GameButtonWithIcon
                                colorStart={colors[0]}
                                colorEnd={colors[1]}
                                icon={info_icon}
                                width={194}
                                height={40}
                                fontSize={20}
                                iconSize={20}
                                marginText={10}
                                title={station.name}
                                onClick={() => {
                                    this.props.openStationInformation(station)
                                }}
                            />
                        </div>
                        <div style={cardResource}>
                            <GameButtonWithIcon
                                tooltip={"Локомотивные бригады"}
                                colorStart={colors[0]}
                                colorEnd={colors[1]}
                                icon={loco_brigade_icon}
                                width={58}
                                height={30}
                                title={GameController.calculateAvailableLocoBrigades(station)}
                                onClick={() => {
                                    this.handlePopup(<BuyContractorsPopup
                                        parent={this}
                                        isRight={this.isRightCard()}
                                        stationId={this.props.station.id}
                                        onClose={this.closeByX.bind(this)}
                                        teamID={this.props.teamID}/>);
                                    this.forceUpdate();
                                }}
                            />
                            <CurrencyCard
                                title={"Станционные бригады"}
                                icon={brigade_icon}
                                value={station.brigades + GameData.CurrentGame.getRentedBrigades("station", this.props.station.id)}
                                size={20}
                                fontSize={20}
                            />
                            <GameButtonWithIcon
                                tooltip={"Трудозатраты"}
                                colorStart={colors[0]}
                                colorEnd={colors[1]}
                                icon={brigade_chips_icon}
                                width={58}
                                height={30}
                                title={stationWorkhours}
                                onClick={() => {
                                    let popup = <BuyWorkhourPopup
                                        parent={this}
                                        isRight={this.isRightCard()}
                                        id={this.props.station.id}
                                        teamID={this.props.teamID}
                                        type={"station"}
                                        brigades={this.props.station.brigades}
                                        additionalChips={this.props.station.additionalChips}
                                        onClose={this.closeByX.bind(this)}
                                    />;

                                    this.handlePopup(popup);
                                    this.forceUpdate();
                                }}
                            />
                        </div>
                    </div>
                    <div style={block2}>
                        <GameButtonWithIcon
                            colorStart={colors[0]}
                            colorEnd={colors[1]}
                            icon={loco_icon}
                            width={194}
                            height={40}
                            fontSize={20}
                            title={"Купить"}
                            marginText={10}
                            style={{
                                margin: "5px"
                            }}
                            onClick={() => {
                                this.handlePopup(<BuyLocoPopup isRight={this.isRightCard()}
                                                               stationId={this.props.station.id}
                                                               teamID={this.props.teamID}/>);
                                this.forceUpdate();
                            }}
                        />
                        {this.getCurrentStateButton(colors)}
                    </div>
                </div>
                {!this.isBottomCard() ? <div className={"train-cards-container"} style={trainCardsStyle}>{this.getTrainCards()}</div> : ""}
            </div>
            {this.props.canShow && (!this.isRightCard() ? "" : this.popup)}
        </div>
    }
}
